module.exports = __webpack_public_path__ + "static/img/12-3new1.534d30f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/12-3new1.png
// module id = aMvV
// module chunks = 15